import { AlertCircle, AlertTriangle, Info } from 'lucide-react'
import type { ConceptSeverity } from '@/services/api/schemas'

/**
 * Per-severity presentation (label key, badge/row classes, icon) shared by every
 * finding renderer: the playground `FindingsPanel`, the schema-detail validation
 * panel, the edit-dialog rejection panel, and the inline row badges. Lives in the
 * schema feature layer so the shared components don't reach up into the admin
 * playground for it.
 */
export const SEVERITY_META: Record<
  ConceptSeverity,
  { labelKey: string; badgeClass: string; rowClass: string; Icon: typeof AlertCircle }
> = {
  error: {
    labelKey: 'schemaAgent.editor.severity.error',
    badgeClass: 'bg-destructive text-destructive-foreground',
    rowClass: 'border-destructive/50 bg-destructive/5',
    Icon: AlertCircle,
  },
  warning: {
    labelKey: 'schemaAgent.editor.severity.warning',
    badgeClass: 'bg-warning text-warning-foreground',
    rowClass: 'border-warning/50 bg-warning/5',
    Icon: AlertTriangle,
  },
  hint: {
    labelKey: 'schemaAgent.editor.severity.hint',
    badgeClass: 'bg-muted text-muted-foreground',
    rowClass: 'border-border bg-muted/40',
    Icon: Info,
  },
  meta: {
    labelKey: 'schemaAgent.editor.severity.meta',
    badgeClass: 'bg-secondary text-secondary-foreground',
    rowClass: 'border-border bg-secondary/30',
    Icon: Info,
  },
}
